import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Spinner, Card, Row, Col } from "react-bootstrap";
import { apibasicauth } from "../Utils/Credentials";
import { BASE_URL_API_BLOG } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";

const AuthorPage = () => {
    const history = useHistory();

  const { slug } = useParams();
  const { username, password } = apibasicauth;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
      const { siteid} =
      useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [authorData, setAuthorData] = useState({});
  const [blogData, setBlogData] = useState([]);

  const fetchBlogsByAuthor = async (authorSlug) => {
    setLoading(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ author_slug: authorSlug, webid: siteid }),
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetBlogsByAuthors`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0" && data.data.length > 0) {
        const authorInfo = data.data[0];
        setAuthorData({
          name: authorInfo.author_name,
          image: authorInfo.author_image,
        });
        setBlogData(authorInfo.posts || []);
      } else {
        setBlogData([]);
      }
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setBlogData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) fetchBlogsByAuthor(slug);
  }, [slug]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center my-5 w-100">
        <Spinner animation="border" variant="success" />
      </div>
    );
  }

  return (
    <div
      className="p-3"
      style={{
        height: "90vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
         <button
         onClick={() => history.goBack()}
        style={{
          marginBottom: "10px",
          padding: "5px 15px",
          borderRadius: "0.5rem",
          border: "none",
          background: "#4f46e5",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
        }}
      >
        ← Back
      </button>
      <div
        className="d-flex flex-column flex-md-row align-items-center justify-content-center mb-3"
        style={{
          width: "100%",
          minHeight: "120px", background: "linear-gradient(90deg, #6ec1ff, #004080)",
          color: "#fff",
          padding: "10px 20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          textAlign: "center",
          borderRadius: "0.5rem",
          overflow: "hidden",
        }}
      >
        {/* Avatar */}
        {authorData.image ? (
          <img
            src={authorData.image}
            alt={authorData.name}
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              border: "2px solid #fff",
              objectFit: "cover",
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
              marginRight: "15px",
            }}
          />
        ) : (
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.8rem",
              fontWeight: "bold",
              color: "#fff",
              marginRight: "15px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            {authorData.name?.charAt(0)}
          </div>
        )}

        {/* Author Info */}
        <div className="d-flex flex-column align-items-center align-items-md-start">
          <h3 style={{ fontWeight: "700", fontSize: "1.3rem", margin: 0 }}>
            {authorData.name}
          </h3>
          {authorData.bio && (
            <p
              style={{
                fontSize: "0.85rem",
                color: "rgba(255,255,255,0.9)",
                margin: 0,
              }}
            >
              {authorData.bio}
            </p>
          )}
        </div>
      </div>

      <Row className="g-3">
        {blogData.length === 0 ? (
          <p>No blogs found for this author.</p>
        ) : (
          blogData.map((post) => (
            <Col
              key={post.post_id}
              lg={3}
              md={3}
              sm={6}
              xs={12}
              className="p-1"
            >
              <Card className=" p-0">
                {post.post_featured_image && (
                  <Card.Img
                    variant="top"
                    src={post.post_featured_image}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                )}
                <Card.Body style={{ padding: "0.5rem" }}>
                  <Card.Title
                    style={{
                      fontSize: "0.95rem",
                      color: "#000",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginBottom: "0.3rem",
                    }}
                  >
                    {post.post_title}
                  </Card.Title>
                  <Card.Text
                    style={{
                      fontSize: "0.8rem",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {post.post_excerpt}
                  </Card.Text>
                  <span style={{ fontSize: "0.7rem", color: "#555" }}>
                    {new Date(post.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </div>
  );
};

export default AuthorPage;
